import React from 'react';

/**
 * Renders plain text with minimal formatting support: paragraphs
 * (blank-line separated) and **bold** spans. Not a full markdown renderer —
 * just enough for content like background theory's "**What is this?**"
 * labels to render bold, each on its own line.
 */
const renderBoldSegments = (line, keyPrefix) =>
  line
    .split(/(\*\*[^*]+\*\*)/g)
    .filter((part) => part !== '')
    .map((part, i) => {
      const match = part.match(/^\*\*([^*]+)\*\*$/);
      return match ? <strong key={`${keyPrefix}-${i}`}>{match[1]}</strong> : part;
    });

const FormattedText = ({ text, className }) => {
  if (!text) return null;

  const paragraphs = text
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <div className={className}>
      {paragraphs.map((paragraph, index) => (
        <p key={index}>{renderBoldSegments(paragraph, index)}</p>
      ))}
    </div>
  );
};

export default FormattedText;
